import { createActions } from 'redux-actions';
import { HealthClaim } from '@models/HealthClaim';
import { GetHealthClaimParams, UploadHealthClaimDocumentsParams } from '@apis/HealthClaimApi';

export type State = {
  healthClaim: HealthClaim | null | undefined;
};
export type HealthClaimFetchPayload = GetHealthClaimParams;
export type HealthClaimUploadDocumentsPayload = UploadHealthClaimDocumentsParams;
export type StateUpdatePayload = Partial<State>;

export const {
  healthClaimFetch,
  healthClaimUploadDocuments,

  stateUpdate,
} = createActions(
  'HEALTH_CLAIM_FETCH',
  'HEALTH_CLAIM_UPLOAD_DOCUMENTS',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_DETAILS_HEALTH_CLAIM_DETAILS',
  },
);
